<template>
  <div class="main-content">
    <div class="card" v-if="storeData.length">
      <div class="card-header bg-success">
        <h5>Реализация препаратов</h5>
      </div>
      <div class="card-body">
        <p>Выберите препарат для реализации</p>
        <DrugSearchNew ref="searchDrug" :drugsForSearch="storeData.map((r) => r.drug)"
                       :onSelect="(d) => selectDrug(d)"/>
        <div v-if="drugsForClose.length">
          <table class="table mt-0 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Кол.</th>
              <th>цена</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in drugsForClose" :key="r.drug.id">
              <td>{{ i + 1 }}</td>
              <td>{{ r.drug.title }}</td>
              <td><input v-model="r.qty" type="number" placeholder="Кол." class="form-control"></td>
              <td><input v-model="r.price" type="number" placeholder="Цена" class="form-control"></td>
              <td>
                <button @click="removeDrug(r.drug.id)" class="btn btn-default" type="button"><i
                  class="icon-fa icon-fa-remove"/>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-info">
        <h5>На реализации (склад)</h5>
      </div>
      <div class="card-body">
        <table class="table mt-0 table-sm table-striped table-hover">
          <tbody>
          <tr v-for="(s,i) in storeData">
            <td>{{ i + 1 }}</td>
            <td>{{ s.drug.title }}</td>
            <td>{{ s.qty }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-info">
        <h5>Накладные</h5>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading.store" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table mt-0 table-sm table-striped table-hover">
          <thead>
          <tr>
            <th width="50px"></th>
            <th width="150px">Накладная</th>
            <th width="150px">Дата</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(inv,i) in invoices">
            <td>{{ i + 1 }}</td>
            <td>
              <button @click="showInvoice(inv.id)" class="btn btn-xs btn-info">
                <i class="icon-fa icon-fa-eye"></i>
              </button>
              {{ inv.id }}
            </td>
            <td>{{ printDate(inv.delivery_date, 'DD.MM.YYYY') }}</td>
            <td>препаратов: <strong>{{ inv.details.length }}</strong> на сумму
              <strong>{{ inv.details.reduce((acc, d) => acc + (+d.qty * +d.cost_price), 0) }}</strong>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {DrugSearchNew},
  data() {
    return {
      selectedStoreId: 85,
      storeData: [],
      drugsForClose: [],
      invoices: [],
      loading: {
        store: false,
      }
    }
  },
  created() {
    this.getStoreData();
  },
  methods: {
    removeDrug(id) {
      this.drugsForClose = this.drugsForClose.filter((d) => d.drug.id !== id);
    },
    selectDrug(drug) {
      if (!drug) return;
      if (this.drugsForClose.map((d) => d.drug.id).includes(drug.id)) return;
      this.drugsForClose.push({drug: drug, qty: 0, price: 0});
      this.$refs.searchDrug.drug = null;
    },
    showInvoice(id) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editOrderInvoice', invoiceId: id},
        // callBackAction: () => this.getRecords(this.paginator?.current_page || 1)
      });
    },
    async getStoreData() {
      this.loading.store = true;
      const {data} = await api.index('/new/stores/actual/' + this.selectedStoreId);
      this.storeData = data.records;
      this.invoices = data.invoices;
      this.loading.store = false;
    }
  }
}

</script>
